var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M418.5 512c-13 0-25.6-5.1-34.8-14.4L256 369.9 128.3 497.6c-19.2 19.2-50.3 19.2-69.5 0l-44.3-44.3c-19.2-19.2-19.2-50.3 0-69.5L142.1 256 14.4 128.3c-19.2-19.2-19.2-50.3 0-69.5l44.3-44.3c19.2-19.2 50.3-19.2 69.5 0L256 142.1 383.7 14.4c19.2-19.2 50.3-19.2 69.5 0l44.3 44.3c19.2 19.2 19.2 50.3 0 69.5L369.9 256l127.7 127.7c19.2 19.2 19.2 50.3 0 69.5l-44.3 44.3c-9.2 9.3-21.7 14.5-34.8 14.5z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4C89",
    d: "m355.7 256 134.8-134.8c15.3-15.3 15.3-40.1 0-55.4l-44.3-44.3c-15.3-15.3-40.1-15.3-55.4 0L256 156.3 121.2 21.5c-15.3-15.3-40.1-15.3-55.4 0L21.5 65.8c-15.3 15.3-15.3 40.1 0 55.4L156.3 256 21.5 390.8c-15.3 15.3-15.3 40.1 0 55.4l44.3 44.3c15.3 15.3 40.1 15.3 55.4 0L256 355.7l134.8 134.8c15.3 15.3 40.1 15.3 55.4 0l44.3-44.3c15.3-15.3 15.3-40.1 0-55.4z",
    opacity: 1,
    "data-original": "#ff2147",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.64e0014b519b1bfb8ee4677ac56bc406.svg";
export { ForwardRef as ReactComponent };